import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState } from 'editor/src/store/design/types';

const setStateReducer = (state: DesignState, action: PayloadAction<DesignState>) => action.payload;

export default setStateReducer;
